<template>
  <div class="dashboard">
    <ApplicationOverview/>
  </div>
</template>

<script>
// @ is an alias to /src
import ApplicationOverview from "../components/dashboard/ApplicationOverview"

export default {
  name: 'dashboard',
  components: {
    ApplicationOverview: ApplicationOverview
  },
}
</script>


<style>

.dashboard > div {
  margin: 50px 0;
}

</style>
